import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Moment } from 'moment';
import moment from 'moment';

import { AutoNumericDirective } from '../../../directives/auto-numeric.directive';
import { BaseUI } from '../../base.ui';
import { OrderAction, ProductInterface, SelectedProductInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { Id } from 'src/app/main/domain/data';

@Component({
    selector: 'thr-operate-subscription-period',
    templateUrl: './operate-subscription-period.component.html',
    styleUrls: ['./operate-subscription-period.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OperateSubscriptionPeriodComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public initialAmount;

    @Input()
    editable = true;

    @Input()
    product: ProductInterface;

    @Input()
    selectedProduct: SelectedProductInterface;

    @Input()
    canExonerate = false;

    @Output()
    detail: EventEmitter<Id> = new EventEmitter();

    @Output()
    exonerate: EventEmitter<Id> = new EventEmitter();


    @ViewChild('autoNumericDirective')
    autoNumericDirective: AutoNumericDirective;

    constructor(parentEvents: ParentEvents, private cdr: ChangeDetectorRef) {
        super(parentEvents);
    }

    ngOnInit() {
        this.initialAmount = this.selectedProduct.order.amount || 0;
        this.cdr.detectChanges();

        if (this.editable) {
            this.selectedProduct.order.action = OrderAction.AMOUNT;
            this.selectedProduct.order.withShares = false;
            this.cdr.detectChanges();
        }
    }

    get minimumInvestment(): number {
        return 0.01;
    }

    get maximumInvestment(): number {
        return 999999;
    }

    get minStartDate(): Date {
        const min = moment().add(1, 'days');
        if (min.isoWeekday() === 6 || min.isoWeekday() === 7) {
            min.weekday(7);
        }
        return min.toDate();
    }

    filterWeekend = (d: Moment): boolean => {
        return d && d.isoWeekday() !== 6 && d.isoWeekday() !== 7;
    };

    onAmountChange() {
        setTimeout(() => {
            if (this.autoNumericDirective) {
                this.selectedProduct.order.amount = this.autoNumericDirective.value;
            }

            if (this.product) {
                this.selectedProduct.order.shares = Number((this.selectedProduct.order.amount / this.product.lastPrice).toFixed(8));
            }

            this.cdr.detectChanges();
        });
    }

    onResize() {
        this.parentEvents.resize();
    }

    onExonerate() {
        this.exonerate.emit(this.product.id as Id);
    }
}
